import { Affix } from 'antd';
import React from 'react';

import './yettey-footer.scss';

import Navbar from '../navbar/navbar';

export interface YetteyFooterProps {
  isMobile: boolean;
}

export const YetteyFooter: React.FC<YetteyFooterProps> = (props) => {
  return props.isMobile ? (
    <Affix offsetBottom={0} className="yettey-footer">
      <Navbar />
    </Affix>
  ) : null;
};

export default YetteyFooter;
